import VCCapitalCall from './VCCapitalCall';

export default VCCapitalCall;
